import { CUSTOM_TRANSCRIPTION_TYPE } from "./survey.js";
const isConditional = (element) => element.visible === false || element.visibleIf !== undefined;
const collect = (element, ancestorConditional, into) => {
    const conditional = ancestorConditional || isConditional(element);
    const children = element.elements ?? element.templateElements;
    if (children) {
        children.forEach((child) => collect(child, conditional, into));
        return;
    }
    if (!element.name)
        return;
    into.push({
        name: element.name,
        title: element.title ?? element.name,
        type: element.type ?? "",
        aiSummaryEnabled: element.aiSummaryEnabled === true,
        conditionallyVisible: conditional,
    });
};
const parseSurveyStructure = (surveyTypeJson) => {
    if (!surveyTypeJson)
        return [];
    let parsed;
    try {
        parsed = JSON.parse(surveyTypeJson);
    }
    catch {
        return [];
    }
    const questions = [];
    (parsed.pages ?? []).forEach((page) => collect(page, isConditional(page), questions));
    return questions;
};
const aiQuestionNames = (questions) => questions
    .filter((question) => question.aiSummaryEnabled && !question.conditionallyVisible)
    .map((question) => question.name);
const transcriptQuestion = (questions) => questions.find((question) => question.type === CUSTOM_TRANSCRIPTION_TYPE) ??
    null;
export const recordableStructure = (surveyTypeJson) => {
    const questions = parseSurveyStructure(surveyTypeJson);
    const transcript = transcriptQuestion(questions);
    const questionNames = aiQuestionNames(questions);
    if (!transcript || questionNames.length === 0)
        return null;
    return { transcriptQuestion: transcript, questionNames };
};
//# sourceMappingURL=surveyStructure.js.map